import React from 'react';
import { TRANSPARENT } from '@nokia-csf-uxr/freeform-design-tokens/tokens/colors';
import { getSvgWidth, getSvgHeight } from './svg-size';

interface InsideHexSvgProps {
  size: string;
  location: any
}

const InsideHexSvg = React.forwardRef<SVGSVGElement, InsideHexSvgProps>((props, ref) => {
  const { size, location } = props;
  return (
    <div style={{ position: 'absolute', ...location }}>
      <svg ref={ref} width={`${getSvgWidth(size)}px`} height={`${getSvgHeight(size)}px`} viewBox="0 0 46 40">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M35.6535164,2.0061155 L44.8535164,18.0061155 C45.5633495,19.2406078 45.5633495,20.7593922 44.8535164,21.9938845 L35.6535164,37.9938845 C34.939913,39.2349339 33.6174754,40 32.1858912,40 L13.8141088,40 C12.3825246,40 11.060087,39.2349339 10.3464836,37.9938845 L1.14648359,21.9938845 C0.436650535,20.7593922 0.436650535,19.2406078 1.14648359,18.0061155 L10.3464836,2.0061155 C11.060087,0.765066109 12.3825246,2.62977757e-16 13.8141088,0 L32.1858912,0 C33.6174754,-2.62977757e-16 34.939913,0.765066109 35.6535164,2.0061155 Z"
            fill={TRANSPARENT}
          />
        </g>
      </svg>
    </div>
  );
});

InsideHexSvg.displayName = 'InsideHexSvg';
export { InsideHexSvg as default };
